export enum BeneficiaryList {
  CONTACTS = 'contacts',
  ACCOUNTS = 'accounts',
  CATALOGUES = 'catalogues',
}
